<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Voeg een nieuwe Survey toe</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeNewSurveyDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-0 pa-1" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="addSurveyForm" lazy-validation>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          hide-details
          label="Naam"
          v-model.trim="newSurvey.name"
          autocomplete
          background-color="background"
          prepend-inner-icon="label"
          required
        ></v-text-field>
        <v-text-field
          class="mt-4"
          outlined
          :color="companyPrimaryColor"
          background-color="background"
          label="Omschrijving"
          v-model.trim="newSurvey.description"
          autocomplete
          hint="Vul een korte omschrijving in van deze  Survey"
          prepend-inner-icon="info"
          persistent-hint
          required
        ></v-text-field>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeNewSurveyDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              dark
              rounded
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              :color="companySecondaryColor"
              @click="addSurvey()"
            >
              Survey toevoegen
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";

export default {
  name: "add-survey-form",
  props: {
    activeComp: Object,
  },

  data() {
    return {
      newSurvey: {
        name: null,
        description: null,
      },
      journeyTypes: [
        {
          name: "Algemeen",
          id: "global",
        },
        {
          name: "Individueel",
          id: "business",
        },
      ],
      feedback: null,
    };
  },

  methods: {
    closeNewSurveyDialog() {
      this.$emit("newSurveyDialogChange", false);
      this.newSurvey.name = null;
      this.newSurvey.description = null;
    },

    addSurvey() {
      if (this.newSurvey.name && this.newSurvey.description) {
        db.collection("widgetSurveys")
          .add({
            name: this.newSurvey.name,
            description: this.newSurvey.description,
            companyId: this.activeComp.id,
            questions: new Array(),
            disclaimer: "",
            intro: "",
            askPhone: false,
            results: new Array(),
            showResult: false,
            useNextButton: false,
            useMautic: false,
            mauticUrl: "",
            mauticEmailId: null,
            color: "",
            useSuccessPage: false,
            successPageUrl: "",
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action: "Nieuwe Survey toegevoegd: " + this.activeComp.name,
                extra:
                  "<b>Naam:</b> " +
                  this.newSurvey.name +
                  "<br>" +
                  "<b>Omschrijving:</b> " +
                  this.newSurvey.description,
              })
              .catch((error) => {
                console.error("Error logging new branch: ", error);
              });
          })
          .then(() => {
            this.$emit("updateData");
            this.closeNewSurveyDialog();
            this.$refs.addSurveyForm.reset();
          })
          .catch((error) => {
            console.error("Error adding Journey: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action: "Error adding Journey: " + this.activeComp.name,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback = "Vul alle velden in om een Survey toe te voegen";
      }
    },
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    languages() {
      let activeLanguages = [];
      if (this.activeComp.languages) {
        this.activeComp.languages.forEach((language) => {
          let activeLanguage = {};
          if (language == "nl") {
            activeLanguage.code = "nl";
            activeLanguage.name = "Nederlands";
            activeLanguages.push(activeLanguage);
          } else if (language == "en") {
            activeLanguage.code = "en";
            activeLanguage.name = "Engels";
            activeLanguages.push(activeLanguage);
          }
        });

        return activeLanguages;
      } else {
        return activeLanguages;
      }
    },
  },
};
</script>
